<template>
<div class="container d-page">
    <div class="d-page-title">
        <d-page-header :title="title" :subtitle="subtitle"></d-page-header>
    </div>
    <div v-if="hasheaderslot" class="d-page-card-header" :class="cardcss">
        <slot name="header"></slot>
    </div>
    <div v-if="hasfilterslot" class="d-page-card-filter" :class="cardcss">
        <slot name="filter"></slot>
    </div>
    <d-page-card v-if="hasdefaultslot" :class="cardcss">
        <slot></slot>
    </d-page-card>
    <div v-if="hasemptyslot">
        <slot name="empty"></slot>
    </div>
</div>
</template>


<script setup>

import { computed, useSlots,defineProps } from 'vue'
const slots = useSlots();

const props = defineProps({        
    title: { type: String, required: true},
    subtitle: { type: String, required: false},
    shadow: { type: Boolean, default: false},
    border: { type: Boolean, default: false},
})

const hasheaderslot = computed(() => slots.header)
const hasfilterslot = computed(() => slots.filter)
const hasdefaultslot = computed(() => slots.default)
const hasemptyslot = computed(() => slots.empty)
const cardcss = computed(() => {
    var css = "";
    if(props.shadow)
        css += " d-shadow";
    if(props.border)
        css += " border";
    return css;
})

</script>
